import { NoteDuration } from "../model/core";
import { workspaceStore } from "../stores/WorkspaceStore";
import { RydKeybindingTypes } from "./common";

export namespace NoteKB {
    export type KeybindingHandlers = {
        increaseNoteDuration: RydKeybindingTypes.VoidHandler,
        decreaseNoteDuration: RydKeybindingTypes.VoidHandler
    };

    export function create(): KeybindingHandlers {

        return {
            increaseNoteDuration: () => {
                const old = workspaceStore.getState().uiState.newNoteDuration;
                const newDuration = new NoteDuration(old.value * 2);
                workspaceStore.getState().setUIState({ ...workspaceStore.getState().uiState, newNoteDuration: newDuration } );
            },
            decreaseNoteDuration: () => {
                const old = workspaceStore.getState().uiState.newNoteDuration;
                if (old.value <= 1) return;
                const newDuration = new NoteDuration(old.value / 2);
                workspaceStore.getState().setUIState({ ...workspaceStore.getState().uiState, newNoteDuration: newDuration });
            }
        };
    }
}